/**
 * Turkiz Press — Sidebar Component
 *
 * Sidebar behaviors: sticky positioning, widget toggles.
 *
 * @package TurkizPress
 * @since   2.0.0
 */

/**
 * Initialize sidebar enhancements.
 */
export function init() {
    setupWidgetToggles();
}

/**
 * Allow collapsible widget sections on mobile.
 */
function setupWidgetToggles() {
    if ( window.innerWidth > 768 ) return;

    const widgetTitles = document.querySelectorAll( '.widget-title' );

    widgetTitles.forEach( ( title ) => {
        title.setAttribute( 'role', 'button' );
        title.setAttribute( 'tabindex', '0' );
        title.setAttribute( 'aria-expanded', 'true' );

        title.addEventListener( 'click', () => toggleWidget( title ) );
        title.addEventListener( 'keydown', ( e ) => {
            if ( e.key === 'Enter' || e.key === ' ' ) {
                e.preventDefault();
                toggleWidget( title );
            }
        } );
    } );
}

/**
 * Toggle widget content visibility.
 * @param {HTMLElement} title Widget title element
 */
function toggleWidget( title ) {
    const content  = title.nextElementSibling;
    if ( ! content ) return;

    const isHidden = content.style.display === 'none';
    content.style.display = isHidden ? '' : 'none';
    title.setAttribute( 'aria-expanded', isHidden );
}
